import appConstants from "../../../../../../appConstants";
import { NumericEditor } from "../../../../../dataGrid/cellEditors";

export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ZoneMiles,
      keyColumn: "zoneSpeedProfileId",
      enableFilters: false,
      enableSorting: false,
      columns: [
        {
          headerName: "ID",
          field: "zoneSpeedProfileId",
          hide: true,
          headerTooltip: "Zone Mile ID"
        },
        {
          headerName: "Zone Miles",
          valueFormatter: params => `${params.data.lowerRangeMile.toString()} - ${params.data.higherRangeMile.toString()}`,
          headerTooltip: "Zone Miles"
        },
        {
          headerName: "Speed (Miles/hour)",
          field: "zoneSpeed",
          headerTooltip: "Speed",
          editable: true,
          cellEditorFramework: NumericEditor
        }
      ]
    }
  }
}

